/**
 * 忘れ物の分類リスト。
 *
 * 清掃員は DAY1 のスタッフも多いため、カテゴリを自分で判断させず、
 * Yes/No の2択（Q1: 廃棄してよいか → Q2: 貴重品か）で正しいカテゴリへ到達させる。
 * ここは画面に表示する具体例なので、サーバーから取らずハードコードする
 * （分類が変わるときは文言ごと変わるため）。
 */

// 保管場所の写真の必須枚数。API 側のバリデーションと合わせている。
export const LostItemMinImageCount = 1
export const LostItemMaxImageCount = 3

// Q1 で表示する。該当すれば報告不要でそのまま廃棄する。
export const DisposalExamples = [
    "食品・飲料（ペットボトル、缶など）",
    "液体・化粧品（開封済み）",
    "衛生用品（歯ブラシ、カミソリなど）",
    "明らかに壊れている物品",
    "レシート・包装紙・空き袋"
]

// Q2 で表示する。該当すれば貴重品として1点ずつ報告する。
export const ValuableExamples = [
    "電子機器（スマホ、PC、タブレットなど）",
    "財布・現金・クレジットカード",
    "パスポート・免許証・マイナンバーカード",
    "時計・ブランドバッグ・貴金属",
    "鍵類（家の鍵・車の鍵）"
]
